const amActionTypes = {
    TOGGLE_SIDE_MENU: 'TOGGLE_SIDE_MENU',
    CLOSE_SIDE_MENU: 'CLOSE_SIDE_MENU',
};

export default amActionTypes;
